import { render, staticRenderFns } from "./move.vue?vue&type=template&id=52993a6b&scoped=true"
import script from "./move.vue?vue&type=script&lang=ts"
export * from "./move.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52993a6b",
  null
  
)

export default component.exports